import Frame from "../../common/Frame";
import React, {useState} from "react";
import Footer from "../../common/Footer";
import {appdata} from "../../../logic_tmp/appdata/AppData";
import {MySpinner} from "../../common/MySpinner";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import {init} from "../../../backend/connectors/JavaConnector";


export function CashPage() {
    const {t} = useTranslation();
    const history = useHistory();
    const [busy, setBusy] = useState();
    const [phone, setPhone] = useState(appdata.customerPhone);
    const [phoneError, setPhoneError] = useState("");
    const [error, setError] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            selectCash();
        }
    }

    const handlePhoneChange = (value) => {
        setPhone(value);
        // @ts-ignore
        setPhoneError("");
    }

    function validate() {
        if (phone === undefined) { // @ts-ignore
            setPhoneError(t("Mandatory!"));
            return false;
        }

        if (!telephoneCheck(phone)) { // @ts-ignore
            setPhoneError(t("5DigitsMin!"));
            return false;
        }
        return true;
    }

    function telephoneCheck(str) {
        return (str.match(/\d/g) || []).length > 5;
    }

    function selectCash() {
        if (busy) return;
        // @ts-ignore
        setBusy(true);
        // @ts-ignore
        setError("");
        ReactPixel.init('325830968618472');
        ReactPixel.track('InitiateCheckout');
        appdata.paymentMethod = "CASH";
        appdata.paymentInstrument = "CASH";
        // @ts-ignore
        appdata.customerPhone = phone;
        if (appdata.customerEmail === "skip@duoclassico.eu") {
            appdata.messageKey = "ThanksIConnectYou"
            history.push("/genericMessage");
            return
        } else
            init()
                .then(response => {
                    if (response.status !== 200) {
                        console.log(response)
                        return;
                    }
                    appdata.messageKey = "ThanksIConnectYou"
                    history.push("/genericMessage");
                })
                .catch((error) => {
                    return Promise.reject(error)
                })
                .finally(() => {
                    setBusy(false);
                });
    }

    // @ts-ignore
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t("PleaseLeavePhoneIWillContactYou")}
                </h2>
                <div>
                    <form className="app-form" method="post" id="lead_form" onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="text"
                                name="phone"
                                onChange={e => handlePhoneChange(e.target.value)}
                                className="form-control"
                                placeholder="Phone"
                                id="phone"
                                value={phone}
                            />
                            <div className="text-danger">{phoneError}</div>
                        </div>
                        <p className="app-text">
                            {error}
                        </p>
                        <div className="app-button d-flex justify-content-around">
                            <button id="nextButton" type="submit" className="app-btn app-btn-further next-step-btn">
                                {busy ? <MySpinner/> : <span>{t("NextButton")}</span>}
                            </button>
                        </div>
                    </form>
                </div>

                <Footer></Footer>
            </Frame>
        </div>
    );
}
